import React, { useState, useEffect, useMemo } from 'react';
import SegundoComponente from './SegundoComponente';   // Login / Registro / Recuperación
import TercerComponente from './TercerComponente';     // Agendamiento de citas

// ====== Contenedor de Login + Citas ======
// Muestra el flujo de login (SegundoComponente) o el flujo de cita (TercerComponente)
// según el flag showAppointment. Permite agendar SIN login usando un "usuario invitado".
const CuartoComponente = ({
  onClose,                 // cierra el modal que contiene este componente
  setAdminLogueado,        // setter para activar admin
  setUserLogueado,         // setter para activar usuario normal
  showAppointment = false, // si true, abre directamente el flujo de citas
  setShowAppointment       // setter para abrir/cerrar citas desde aquí
}) => {
  // --- UI internas del login ---
  const [showRegister, setShowRegister] = useState(false);
  const [showRecovery, setShowRecovery] = useState(false);

  // --- Usuario actual detectado por email (si se escribe en el login) ---
  const [currentUser, setCurrentUser] = useState(null);

  // --- Datos del formulario de login (para detectar usuario o crear invitado) ---
  const [loginData, setLoginData] = useState({ email: '', password: '' });

  // Cuando cambia el email, buscamos ese usuario en localStorage
  useEffect(() => {
    const email = loginData.email;
    if (email) {
      const usuarios = JSON.parse(localStorage.getItem('usuarios')) || [];
      const usuario = usuarios.find(u => u.email === email);
      setCurrentUser(usuario || null);
    } else {
      setCurrentUser(null);
    }
  }, [loginData.email]);

  // === MODO INVITADO (sin textos prellenados) ===
  // Invitado con strings vacíos para NO prellenar los campos en el formulario.
  const guestUser = useMemo(() => ({
    id: 'guest',
    nombre: '',     // sin “Invitado”
    email: '',      // sin “invitado@guest.local”
    tipo: 'guest'
  }), []);

  // Si estamos en flujo de cita:
  // - Si hay usuario real (logueado o detectado por email), úsalo.
  // - Si no, usar invitado SIN textos para que los campos salgan vacíos.
  const effectiveUser = showAppointment ? (currentUser || guestUser) : currentUser;

  // Cierra el flujo de cita y también el modal padre si corresponde
  const handleCloseAppointment = () => {
    if (setShowAppointment) setShowAppointment(false);
    if (onClose) onClose();
  };

  return (
    <>
      {/* Si NO estamos en modo cita -> pantalla de login/registro/recuperación */}
      {!showAppointment ? (
        <SegundoComponente
          onClose={onClose}
          setAdminLogueado={setAdminLogueado}
          setUserLogueado={setUserLogueado}
          setCurrentUser={setCurrentUser}
          showRegister={showRegister}
          showRecovery={showRecovery}
          setShowRegister={setShowRegister}
          setShowRecovery={setShowRecovery}
          setShowAppointment={setShowAppointment}  // permite abrir cita desde el login
          loginData={loginData}
          setLoginData={setLoginData}
        />
      ) : (
        // Si estamos en modo cita -> flujo de agendamiento
        <TercerComponente
          currentUser={effectiveUser}          // puede ser el usuario real o "guest" SIN textos
          onClose={handleCloseAppointment}     // cierra cita (y modal contenedor si aplica)
          setUserLogueado={setUserLogueado}    // se mantiene por compatibilidad con tu flujo

          // ====== Props de "solo despliegue" ======
          // Título deseado en el formulario:
          forceTitle="AGENDA TU CITA"
          // Indicar que no se muestren placeholders ni precargas (si tu TercerComponente lo soporta):
          placeholdersOff={true}
        />
      )}
    </>
  );
};

export default CuartoComponente;
